import PermissionService from 'components/Common/PermissionService';
import React from 'react';
import { DatasetTypesTable } from './DatasetTypes/DatasetTypesTable';
import { Grid, Typography } from '@mui/material';
import { RuntimeParametersTable } from './RuntimeParameters/RuntimeParametersTable';
import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { productPerm } from 'utils/appConstants';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';


export const Taxonomy = () => {
  const { ID: orgId } = useSelector(activeOrgSelector);
  const { crId } = useParams();

  // Feature flag check
  const isRTPMasterSyncEnabled = PermissionService.isProductEnabled(
    [productPerm.RTPsValueConstraints],
  );

  // Determine height: if RTP enabled, use 'auto',
  // else use default which means "fill available space"
  const datasetTableHeight = isRTPMasterSyncEnabled ? 'auto' : undefined;

  return (
    <Grid container direction='column' spacing={4}>

      {/* Dataset Types Section */}
      <Grid item>
        <Typography variant='h5' gutterBottom fontWeight={600}>
          Dataset Types
        </Typography>
        <DatasetTypesTable
          orgId={orgId}
          crId={crId}
          tableHeight={datasetTableHeight}
        />
      </Grid>

      {/* Runtime Parameters Section */}
      {isRTPMasterSyncEnabled && (
        <Grid item>
          <Typography variant='h5' gutterBottom fontWeight={600}>
            Runtime Parameters
          </Typography>
          <RuntimeParametersTable
            orgId={orgId}
            crId={crId}
          />
        </Grid>
      )}

    </Grid>
  );
};
